// extracted by mini-css-extract-plugin
export const form = "contact-form-module--form--34rnL";
export const field = "contact-form-module--field--3LrEn";
export const textarea = "contact-form-module--textarea--LFpGR";
export const input = "contact-form-module--input--3lOyC";
export const button = "contact-form-module--button--2Os-V";